<template>
  <div>
    <el-form ref="form" :model="formData" label-width="80px">

      <el-form-item label="子流程">
        <el-select ref="subselect" v-model="formData.sub" @change="selectCh" placeholder="请选择">
          <el-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.filename"
            :value="item.fid"
            ></el-option>

        </el-select>
      </el-form-item>
      <el-form-item label="打开方式">
        <el-radio-group v-model="formData.opentype">
          <el-radio :label=0>流程</el-radio>
          <el-radio :label=1>接口</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item :label="$t('form_notes')">
        <el-input type="textarea" v-model="formData.desc"></el-input>
      </el-form-item>
     </el-form>
  </div>
</template>
<script>
import * as flowUtil from '@/utils/logicFlowJs.js';
export default {
  name: '',
  props: {
    subData: Object,
    nodeData: Object,
    lf: Object || String,
  },
  watch: {
    formData: {
      handler(n, o) {
        const nodeData = this.$props.nodeData
        this.$props.lf.setProperties(nodeData.id, n);
        this.$props.lf.updateText(nodeData.id, n.text);
      },
      deep:true// 深度监听父组件传过来对象变化
    },

  },
  mounted() {
    const { properties, text } = this.$props.nodeData
    if (properties) {
      this.$data.formData = Object.assign({}, this.$data.formData, properties)
    }

    if (text && text.value) {
      this.$data.formData.text = text.value
    }
   this.loadSubFlowList();

  },
  data() {
    return {
      formData: {
        text: '',
        sub:'',
        opentype:0,
        desc: '',

      },
      options:[],
    }
  },
  methods: {
    selectCh(){
      this.$nextTick(()=> {
        let t = this.$refs.subselect.selected.label;
        this.$data.formData.text = t;
        //console.log("loadFlowType", t);
      })
    },
    //loadFlow模板
    async loadSubFlowList() {

      let param = {"type": "flow"};
      let res = await flowUtil.loadSubFlowList(param);
      if (res.code == 1) {
        //console.log("loadSubFlowList--ok", res)
        this.options= res.data.list;

      } else {

      }
    },
  },
}
</script>
<style scoped>
</style>
